import { type PlatformContract, setPublishingContracts, withFormat } from "@ondit/publishing";
import { useQuery } from "@tanstack/react-query";
import { useMemo } from "react";
import type { PublishingPlatform } from "~/core/api/distribution";
import { api } from "~/core/api/index";
import { keys } from "~/core/query";

/**
 * Pubzu supplies each active contract and fully resolved content type.
 * Directory metadata by itself does not define an executable content type.
 */
export function brandContracts(list: PublishingPlatform[] = []) {
	const all: PlatformContract[] = list.flatMap((p) => (p.contract ? [p.contract] : []));
	setPublishingContracts(all);
	const byId = (id: string) => all.find((p) => p.id === id);
	return {
		all,
		byId,
		/** One kind of post on the platform; the default when `format` is empty. */
		kind: (id: string, format?: string | null) => {
			const p = byId(id);
			return p && withFormat(p, format);
		},
	};
}

export function useBrandContracts(entityId: string) {
	const list = useQuery({
		queryKey: [...keys.entity(entityId), "distribution"],
		queryFn: () => api.distribution(entityId),
		enabled: !!entityId,
	});
	return useMemo(() => brandContracts(list.data?.platforms), [list.data]);
}
